// src/components/molecules/NewsCard.tsx
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import tinycolor from 'tinycolor2';
import { CustomText, CustomImage } from '../atoms';

interface NewsCardProps {
  imageUrl?: string; // URL of the image
  title: string; // Title of the news card
  date: string; // Date to display
  bgColor: string | undefined; // Background color of the card
  secondaryAccentColor?: string; // Secondary accent color for the card (optional)
  newsHeadlineTextColor?: string;
  textColor?: string; // Text color of the card (optional, default is "black")
  id: string | number;
  onClickNewsItem: (id: string | number) => void;
  newsSectionHelperTextReadMore: string;
  newsItemHref: string;
}

export const NewsCard: React.FC<NewsCardProps> = ({
  id,
  imageUrl,
  title,
  date,
  bgColor,
  secondaryAccentColor,
  newsHeadlineTextColor = 'white',
  textColor = 'black',
  onClickNewsItem,
  newsSectionHelperTextReadMore,
  newsItemHref,
}) => {
  // Adjust color for the date (lighter version of textColor)
  const dateColor = tinycolor(textColor).lighten(40).toString();
  return (
    <a href={newsItemHref}>
      <Flex
        borderWidth="1px"
        // borderRadius="lg"
        overflow="hidden"
        backgroundColor={bgColor}
        color={textColor}
        cursor="pointer"
        _hover={{ boxShadow: 'md', transform: 'scale(1.02)' }}
        onClick={e => {
          const isLeftClick = e.button === 0;
          const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
          // SPA routing on normal click
          if (isLeftClick && !isModifiedClick) {
            e.preventDefault();
            onClickNewsItem(id);
          }
        }}
        direction="row"
        height="100%"
      >
        {/* Left Image (30%) */}
        <Box
          flex="0 0 30%"
          height="100%"
          maxW="240px"
          aspectRatio={{ base: 2 / 3, md: 2 / 3 }}
          overflow="hidden"
          p="2"
        >
          {imageUrl && (
            <CustomImage
              src={imageUrl}
              alt={title}
              objectFit="cover"
              width="100%"
              height="100%"
              border={`2px solid ${newsHeadlineTextColor}`}
              borderRadius="0"
            />
          )}
        </Box>

        {/* Right Content (70%) */}
        <Flex flex="0 0 70%" direction="column" p="4" gap="3">
          <CustomText variant="body" color={dateColor} fontSize="sm">
            {date}
          </CustomText>

          <Text fontWeight="bold" fontSize="md" noOfLines={4} color={newsHeadlineTextColor}>
            {title}
          </Text>
          <a href={newsItemHref}>
            {' '}
            <Text
              variant="body"
              fontSize="xs"
              fontWeight="bold"
              color={secondaryAccentColor}
              cursor="pointer"
              _hover={{ textDecoration: 'underline' }}
              onClick={e => {
                const isLeftClick = e.button === 0;
                const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
                // SPA routing on normal click
                if (isLeftClick && !isModifiedClick) {
                  e.preventDefault();
                  onClickNewsItem(id);
                }
              }}
              mt="auto"
            >
              {newsSectionHelperTextReadMore}
            </Text>
          </a>
        </Flex>
      </Flex>
    </a>
  );
};
